import { render, staticRenderFns } from "./LaserHistory.vue?vue&type=template&id=6024bc8f&scoped=true"
import script from "./LaserHistory.vue?vue&type=script&lang=js"
export * from "./LaserHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024bc8f",
  null
  
)

export default component.exports